import { toast, ToastOptions, Id } from 'react-toastify';
const toastConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  pauseOnFocusLoss: false,
  progress: undefined,
};

interface IMessagePromise {
  pending?: string;
  success?: string;
  error?: string;
}

const info = (message = '', id?: string, options?: ToastOptions): Id =>
  toast(message, {
    ...toastConfig,
    type: 'info',
    toastId: id,
    ...options,
  });

const success = (message: React.ReactNode = '', id?: string, options?: ToastOptions): Id =>
  toast(message, {
    ...toastConfig,
    type: 'success',
    toastId: id,
    ...options,
  });

const warning = (message = '', id?: string, options?: ToastOptions): Id =>
  toast(message, {
    ...toastConfig,
    type: 'warning',
    toastId: id,
    ...options,
  });

const error = (message = '', id?: string, options?: ToastOptions): Id =>
  toast(message, {
    ...toastConfig,
    type: 'error',
    toastId: id,
    ...options,
  });

const show = (message = '', id?: string, options?: ToastOptions): Id =>
  toast(message, {
    ...toastConfig,
    type: 'default',
    toastId: id,
    ...options,
  });

const asyncPromise = <T>(
  message: IMessagePromise,
  promise: Promise<T>,
  id?: string
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    toast.promise(
      promise.then(resolve).catch(reject),
      {
        pending: message.pending,
        success: message.success,
        error: message.error,
      },
      {
        ...toastConfig,
        toastId: id,
      }
    );
  });
};

const remove = (id?: string): void => {
  toast.dismiss(id);
};

export const Notify = {
  info,
  success,
  warning,
  error,
  show,
  asyncPromise,
  remove,
};
